<div id="multi-bar-chart"></div>
